module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-italic.652437fb.ttf";